export const MODULE_ROUTE = "/login";
export const MODULE_NAME = "LOGIN";